import { render, staticRenderFns } from "./versionColors.vue?vue&type=template&id=197bb21f&"
import script from "./versionColors.vue?vue&type=script&lang=js&"
export * from "./versionColors.vue?vue&type=script&lang=js&"
import style0 from "./versionColors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports